import React from 'react';
import { motion } from 'framer-motion';
import { FaHeart, FaInfoCircle } from 'react-icons/fa';
import './PersonalizationIndicator.css';

/**
 * PersonalizationIndicator - Shows how user data personalizes recommendations
 * Displays a badge with explanation of how specific user data affects the current view
 */
function PersonalizationIndicator({ 
  dataPoint, 
  label, 
  impact, 
  icon, 
  color = '#E91E63',
  compact = false 
}) {
  if (!dataPoint && dataPoint !== 0) return null;

  return (
    <motion.div
      className={`personalization-indicator ${compact ? 'compact' : ''}`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.2 }}
    >
      <div className="indicator-badge" style={{ '--indicator-color': color }}>
        {icon && <span className="indicator-icon">{icon}</span>}
        <div className="indicator-content">
          <div className="indicator-label">{label}</div>
          {!compact && impact && (
            <div className="indicator-impact">
              <FaInfoCircle className="impact-icon" />
              <span>{impact}</span>
            </div>
          )}
        </div>
        <FaHeart className="indicator-heart" />
      </div>
    </motion.div>
  );
}

/**
 * PersonalizationBadgeGroup - Shows multiple personalization factors at once
 */
function PersonalizationBadgeGroup({ factors, title = "Personalized for you" }) {
  if (!factors || factors.length === 0) return null;

  return (
    <motion.div
      className="personalization-badge-group"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {title && (
        <div className="badge-group-header">
          <FaHeart className="badge-group-icon" />
          <span className="badge-group-title">{title}</span>
        </div>
      )}
      <div className="badge-group-items">
        {factors.map((factor, idx) => (
          <PersonalizationIndicator
            key={idx}
            dataPoint={factor.value}
            label={factor.label}
            impact={factor.impact}
            icon={factor.icon}
            color={factor.color}
            compact={factor.compact}
          />
        ))}
      </div>
    </motion.div>
  );
}

export default PersonalizationIndicator;
export { PersonalizationBadgeGroup };









